import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "goods_specs"
};
const _hoisted_2 = {
  class: "gs_item"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "gs_left"
}, [/*#__PURE__*/_createElementVNode("div", null, "规格1"), /*#__PURE__*/_createElementVNode("span", null, "规格至少填写1个")], -1);

const _hoisted_4 = {
  class: "gs_right"
};

const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1);

const _hoisted_6 = {
  class: "gs_item"
};

const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "gs_left"
}, [/*#__PURE__*/_createElementVNode("div", null, "规格2"), /*#__PURE__*/_createElementVNode("span", null, "规格至少填写1个")], -1);

const _hoisted_8 = {
  class: "gs_right"
};
import DynamicParams from "@com/DynamicParams.vue";
import { $msg } from "@ui/msg";
import $ from "@util/base";
import { ref, watch } from "vue";
export default {
  __name: 'GoodsSpecs',
  props: {
    data: {
      type: Object
    },
    specs: {
      type: Array
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    isModify: {
      type: Boolean,
      default: false
    }
  },

  setup(__props, {
    expose: __expose
  }) {
    const props = __props;
    const specsOptions = ref([]);
    watch(() => props.specs, val => {
      specsOptions.value = val;
    });
    watch(() => props.data, val => {
      skuSaleAttr1.value = val.skuSaleAttr1;
      skuSaleAttr2.value = val.skuSaleAttr2;
      specsData1.value = hadnerSpecsData(val.skuSaleAttr1Value);
      specsData2.value = hadnerSpecsData(val.skuSaleAttr2Value);
    });
    const specsOptions1 = ref(null);
    const specsOptions2 = ref(null);
    const skuSaleAttr1 = ref(props.data.skuSaleAttr1);
    const skuSaleAttr2 = ref(props.data.skuSaleAttr2);
    const specsData1 = ref(hadnerSpecsData(props.data.skuSaleAttr1Value));
    const specsData2 = ref(hadnerSpecsData(props.data.skuSaleAttr2Value));

    function hadnerSpecsData(value) {
      if ($.isNotEmpty(value)) {
        return value.map(e => {
          return {
            value: e,
            oldValue: e
          };
        });
      } else {
        return [];
      }
    }

    function hasEqualElement(val) {
      const s = new Set();
      val.forEach(e => {
        s.add(e);
      });
      return val.length !== s.size;
    }

    function getValue() {
      let s1 = skuSaleAttr1.value;
      let s2 = skuSaleAttr2.value; // console.log(specsOptions1.value.getValue())

      let so1 = specsOptions1.value.getValue().remove(e => {
        return $.isEmpty(e.value);
      });
      let so2 = specsOptions2.value.getValue().remove(e => {
        return $.isEmpty(e.value);
      });

      if ($.isNotEmpty(so1)) {
        so1 = so1.map(e => {
          return e.value;
        });

        if (hasEqualElement(so1)) {
          $msg.error(s1 + "规格有重复的选项");
          return false;
        }
      } else {
        so1 = null;
      }

      if ($.isNotEmpty(so2)) {
        so2 = so2.map(e => {
          return e.value;
        });

        if (hasEqualElement(so2)) {
          $msg.error(s2 + "规格有重复的选项");
          return false;
        }
      } else {
        so2 = null;
      }

      if ($.isNotEmpty(s1) && $.isNotEmpty(so1) || $.isNotEmpty(s2) && $.isNotEmpty(so2)) {
        return {
          skuSaleAttr1: s1,
          skuSaleAttr2: s2,
          skuSaleAttr1Value: so1,
          skuSaleAttr2Value: so2
        };
      } else {
        $msg.error("规格至少填写1个");
        return false;
      }
    }

    __expose({
      getValue
    });

    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_table_column = _resolveComponent("el-table-column");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_select, {
        modelValue: skuSaleAttr1.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => skuSaleAttr1.value = $event),
        placeholder: "请选择",
        disabled: __props.readOnly || __props.isModify
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(specsOptions.value, (item, index) => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: index,
            label: item.label,
            value: item.value,
            disabled: item.value === skuSaleAttr2.value
          }, null, 8, ["label", "value", "disabled"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "disabled"]), _createVNode(DynamicParams, {
        ref_key: "specsOptions1",
        ref: specsOptions1,
        template: {
          value: null
        },
        data: specsData1.value,
        operation: _unref($).DPOperation(__props.readOnly),
        addText: "添加选项"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "选项",
          align: "center"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_input, {
            modelValue: scope.row.value,
            "onUpdate:modelValue": $event => scope.row.value = $event,
            placeholder: "请输入",
            disabled: __props.readOnly || _unref($).isNotEmpty(scope.row.oldValue)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "operation"])])]), _hoisted_5, _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_select, {
        modelValue: skuSaleAttr2.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => skuSaleAttr2.value = $event),
        placeholder: "请选择",
        disabled: __props.readOnly || __props.isModify
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(specsOptions.value, (item, index) => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: index,
            label: item.label,
            value: item.value,
            disabled: item.value === skuSaleAttr1.value
          }, null, 8, ["label", "value", "disabled"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "disabled"]), _createVNode(DynamicParams, {
        ref_key: "specsOptions2",
        ref: specsOptions2,
        template: {
          value: null
        },
        data: specsData2.value,
        operation: _unref($).DPOperation(__props.readOnly),
        addText: "添加选项"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          label: "选项",
          align: "center"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_input, {
            modelValue: scope.row.value,
            "onUpdate:modelValue": $event => scope.row.value = $event,
            placeholder: "请输入",
            disabled: __props.readOnly || _unref($).isNotEmpty(scope.row.oldValue)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "operation"])])])]);
    };
  }

};